export default __webpack_public_path__ + "static/radovi10-be05048ea8de486abd7868bad9ba292c.jpeg";